import { ProductStickyAddToCart } from "theme";

document.addEventListener("DOMContentLoaded", (event) => {
    if (!customElements.get("custom-product-sticky-add-to-cart")) {
        class CustomProductStickyAddToCart extends ProductStickyAddToCart {
            get endMarker() {
                let footer = document.querySelector(".shopify-section--trust-icons");
                if (!footer) {
                    footer = document.querySelector(".shopify-section--footer");
                }
                return footer;
            }
        }

        customElements.define(
            "custom-product-sticky-add-to-cart",
            CustomProductStickyAddToCart,
        );
    }
});
